import { isEqual } from 'lodash'
import * as ALLOWED_OPERATIONS from '../../allowedOperations'
import type { DigestedSchema } from '@wix/wix-data-client-common-standalone'

export const isWriteOnly = (digestedSchema: DigestedSchema): boolean =>
  isEqual(digestedSchema.allowedOperations, [ALLOWED_OPERATIONS.INSERT])

export const isReadWriteAllowed = (digestedSchema: DigestedSchema): boolean => {
  if (!digestedSchema.allowedOperations) {
    return true
  }

  const readAndRemoveIsAllowed =
    digestedSchema.allowedOperations.includes(ALLOWED_OPERATIONS.READ) &&
    digestedSchema.allowedOperations.includes(ALLOWED_OPERATIONS.REMOVE)

  const readAndUpdateIsAllowed =
    digestedSchema.allowedOperations.includes(ALLOWED_OPERATIONS.READ) &&
    digestedSchema.allowedOperations.includes(ALLOWED_OPERATIONS.UPDATE)

  return readAndRemoveIsAllowed || readAndUpdateIsAllowed
}

export const isReadAllowed = (digestedSchema: DigestedSchema): boolean =>
  !digestedSchema.allowedOperations ||
  digestedSchema.allowedOperations.includes(ALLOWED_OPERATIONS.READ)

export const isWriteAllowed = (digestedSchema: DigestedSchema): boolean =>
  !digestedSchema.allowedOperations ||
  digestedSchema.allowedOperations.includes(ALLOWED_OPERATIONS.INSERT)
